import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CustomTextField from '../common/CustomTextField';
import LeadCard from './LeadCard';
import { useGetLeadsQuery, useUpdateLeadMutation } from '../../redux/services/leadApi';

const handleMarkDuplicate = ({put, is_duplicate_email = true}) => id => async e => {
  let body = {is_duplicate_email};
  if (is_duplicate_email) body.status = 'ARCHIVED';
  const response = await put({
    id,
    body,
  });
};

const LeadDialog = props => {
  const { dialogIsOpen, onClose, afterEdit } = props;
  const [email, setEmail] = useState(props.email || '');
  const [put] = useUpdateLeadMutation();
  const query = useGetLeadsQuery({email: props.email})
  const leads = query?.data?.data || [];
  const onMarkDuplicate = handleMarkDuplicate({put, is_duplicate_email: true});
  const onMarkNotDuplicate = handleMarkDuplicate({put, is_duplicate_email: false});
  return (
    <Dialog
      open={dialogIsOpen}
      fullWidth={true}
      maxWidth='lg'
      onClose={onClose}
    >
      <DialogContent style={{padding: 0}}>
        <Grid container padding={1}>
          <Grid item xs={12} md={12} padding={0} paddingTop={0}>
            <Stack 
              direction='row' 
              justifyContent='flex-end' 
              spacing={1} 
              alignItems='center'
            >
              <IconButton
                onClick={props.onClose}
              >
                <CloseIcon />
              </IconButton>
            </Stack> 
          </Grid>
          <Grid item xs={12} md={12} padding={0} paddingTop={0} textAlign='center'>
            <Typography variant='h2'>Resolve Duplicates</Typography>
            <Typography variant='subtitle2' color='text.muted' paddingTop={.5}>
              Found {leads.length} leads with the same email address: {props.email}.
            </Typography>
          </Grid>
          {leads.map(l => 
            <Grid item xs={12} md={3} padding={2} paddingTop={4}>
              <Stack spacing={1}>
                <LeadCard lead={l} notClickable={true} />
                <Stack direction='row' justifyContent='space-between'>
                  <Box>
                    <Button
                      variant='contained'
                      color='error'
                      size='small'
                      onClick={onMarkDuplicate(l.id)}
                    >
                      Archive
                    </Button>
                  </Box>
                  <Box>
                    <Button
                      variant='contained'
                      color='success'
                      size='small'
                      disabled={!l.is_duplicate_email}
                      onClick={onMarkNotDuplicate(l.id)}
                    >
                      Not a Duplicate
                    </Button>
                  </Box>
                </Stack>
              </Stack>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default LeadDialog;